import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MarketPlaceQuoteRequestService } from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';

import { REQUEST_STEPS } from '../enum-request-steps';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { HoldFileService } from '../../../../services/hold-file-service/hold-file.service';
import { LoginService } from 'src/app/services/login-service/login.service';
import { SdsFileService } from 'src/app/services/sds-repository-file/sds-file.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../services/mixpanel-service/mixpanel.service';
const OTHER = 'Other';

@Component({
  selector: 'app-lease-options',
  templateUrl: './lease-options.component.html',
  styleUrls: ['./lease-options.component.scss'],
})
export class LeaseOptionsComponent implements OnInit, AfterViewInit {
  countries: any[] = [];
  carriers: any[] = [];
  selectedCountryIndex = -1;
  files: any[] = [];
  currentDate = new Date();
  quoteRequest: any;
  objLeaseOptions: any;
  leaseTermOtherIndex = -1;
  public sdsFileList: any[] = [];
  selected: any;
  private config: any = null;

  frmLeaseTerm = new FormGroup({
    'preferred-lease-type': new FormControl(null, [Validators.required]),
    'preferred-lease-term': new FormControl(null, [Validators.required]),
    'preferred-lease-term-other': new FormControl('', [
      Validators.pattern('[a-zA-Z 0-9]{1,55}'),
    ]),
    min: new FormControl('', [Validators.required, Validators.min(1)]),
    max: new FormControl('', [Validators.required, Validators.maxLength(6)]),
    city: new FormControl('', [
      Validators.maxLength(25),
      Validators.pattern('[a-zA-Z ]{1,25}'),
    ]),
    state: new FormControl(''),
    country: new FormControl('', [Validators.required]),
    'preferred-rail-carrier': new FormControl(null, [Validators.required]),
    'preferred-rail-carrier-other': new FormControl('', [
      Validators.pattern('[a-zA-Z 0-9]{1,55}'),
    ]),
    'rail-service-type': new FormControl(null, [Validators.required]),
    leaseableDate: new FormControl('', [Validators.required]),
    flexableDate: new FormControl(true, []),
    comments: new FormControl('', [Validators.maxLength(250)]),
    trinSight: new FormControl(true),
  });

  leaseOptions: any;
  showOther = false;
  showCarrierOther = false;
  showleaseTermOther = false;

  displayTrinsightHelp = false;

  formSubsription: Subscription;

  private _holdFileService_: HoldFileService;
  clientData: any = null;
  loading = true;
  count = 0;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private httpClient: HttpClient,
    holdFileService: HoldFileService,
    private loginService: LoginService,
    private draftQuoteService: draftQuoteRequest,
    private mixpanelService: MixpanelService,
    private sdsService: SdsFileService
  ) {
    this._holdFileService_ = holdFileService;

    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }

    this.loginService.getUser()?.subscribe({
      next: (response: any) => {
        //[{"json_build_object":{"contact-info":{"email":"nelasiry@nexient.com","name":null,"phone":null},"company-info":{"name":null,"address":{"city":null,"postal-code":null,"state":null,"street":null}}}}]
        this.clientData = response[0].json_build_object;
        this.loading = false;

        this.getSdsFileDetails(this.clientData);
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });

    if (this.quoteRequestService.quoteRequest$) {
      this.quoteRequestService.quoteRequest$.subscribe((value) => {
        this.quoteRequest = value;
        this.objLeaseOptions = value['lease-details'];
        this.getOptions();
      });
    }

    this.formSubsription = this.frmLeaseTerm.valueChanges.subscribe(() => {
      this.quoteRequest['lease-details'] = this.createSubmittedObj();
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    let timer: any;
    let minTimer: any;
    let maxTimer: any;
    let cityTimer: any;
    let stateTimer: any;
    let preferredTimer: any;
    let leaseableDateTimer: any;
    // Subscribe to 'preferred-lease-term-other' control value changes
    this.frmLeaseTerm.controls[
      'preferred-lease-term-other'
    ].valueChanges.subscribe((value) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (value) {
          this.trackLeaseTermOtherChange(value);
        }
      }, 1000);
    });

    // Subscribe to 'min' control value changes
    this.frmLeaseTerm.controls['min'].valueChanges.subscribe((value) => {
      clearTimeout(minTimer);
      minTimer = setTimeout(() => {
        if (value) {
          this.trackRailcarsChange('min', value);
        }
      }, 1000);
    });

    // Subscribe to 'max' control value changes
    this.frmLeaseTerm.controls['max'].valueChanges.subscribe((value) => {
      clearTimeout(maxTimer);
      maxTimer = setTimeout(() => {
        if (value) {
          this.trackRailcarsChange('max', value);
        }
      }, 1000);
    });
    // Subscribe to 'city' control value changes
    this.frmLeaseTerm.controls['city'].valueChanges.subscribe((value) => {
      clearTimeout(cityTimer);
      cityTimer = setTimeout(() => {
        if (value) {
          this.trackLocationChange('city', value);
        }
      }, 1000);
    });

    // Subscribe to 'state' control value changes
    this.frmLeaseTerm.controls['state'].valueChanges.subscribe((value) => {
      clearTimeout(stateTimer);
      stateTimer = setTimeout(() => {
        if (value) {
          this.trackLocationChange('state', value);
        }
      }, 1000);
    });

    this.frmLeaseTerm.controls['rail-service-type'].valueChanges.subscribe(
      (value) => {
        clearTimeout(preferredTimer);
        preferredTimer = setTimeout(() => {
          if (value) {
            this.trackRailService(value);
          }
        }, 1000);
      }
    );

    this.frmLeaseTerm.controls['leaseableDate'].valueChanges.subscribe(
      (value) => {
        clearTimeout(leaseableDateTimer);
        leaseableDateTimer = setTimeout(() => {
          if (value) {
            this.trackLeaseableDate(value);
          }
        }, 1000);
      }
    );
  }

  trackRailService(value: any) {
    this.mixpanelService.track({
      eventName: 'What is the type of rail service?',
      eventDisplayName: value?.name,
      kpi: 'User Engagement',
      trigger: 'On Input Change',
      eventDefinition: 'User changed the rail service option',
      propertyType: 'Event Property',
      propertyDefinition: 'rail service',
      additionalProperties: {
        railService: value?.name,
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  trackLeaseableDate(value: any) {
    this.mixpanelService.track({
      eventName: ' When do you need these railcars?',
      eventDisplayName: value?.toString(),
      kpi: 'User Engagement',
      trigger: 'On Input Date Change',
      eventDefinition: 'User changed the date',
      propertyType: 'Event Property',
      propertyDefinition: 'rail service',
      additionalProperties: {
        leaseableDate: value?.toString(),
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  private trackRailCarrierOtherChange(event: any): void {
    this.mixpanelService.track({
      eventName: ' What is your preferred rail carrier?',
      eventDisplayName: event.value.map((item: any) => item.name).join(', '),
      kpi: 'User Engagement',
      trigger: 'On Input Change',
      eventDefinition: 'User changed the preferred rail carrier option',
      propertyType: 'Event Property',
      propertyDefinition: 'Preferred Rail Carrier',
      additionalProperties: {
        preferredRail: event.value.map((item: any) => item.name).join(', '),
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  private trackRailcarsChange(type: string, value: string): void {
    let eventName = '';
    let eventDisplayName = '';

    switch (type) {
      case 'min':
        eventName = ' How many min railcars do you need?';
        eventDisplayName = value;
        break;
      case 'max':
        eventName = ' How many max railcars do you need?';
        eventDisplayName = value;
        break;
      default:
        break;
    }

    this.mixpanelService.track({
      eventName: eventName,
      eventDisplayName: eventDisplayName,
      kpi: 'User Engagement',
      trigger: 'On Input Change',
      eventDefinition: `User changed the ${type === 'min' ? 'Min' : 'Max'} lease cars option`,
      propertyType: 'Event Property',
      propertyDefinition: `${type === 'min' ? 'Min' : 'Max'} Lease cars`,
      additionalProperties: {
        railcars: value,
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  changeCountry() {
    this.frmLeaseTerm.get('state')?.setValue('');
    const countryValue = this.frmLeaseTerm.value.country;
    this.setCountryIndex(countryValue);
    if (countryValue) {
      this.trackLocationChange('country', countryValue);
    }
  }

  private trackLocationChange(type: string, value: string): void {
    let eventName = '';
    let eventDisplayName = '';
    let propertyDefinition = '';

    switch (type) {
      case 'country':
        eventName = ' Where is your first loading location?';
        eventDisplayName = value;
        propertyDefinition = 'Location';
        break;
      case 'state':
        eventName = ' Where is your first loading state location?';
        eventDisplayName = value;
        propertyDefinition = 'Location';
        break;
      case 'city':
        eventName = ' Where is your first loading city location?';
        eventDisplayName = value;
        propertyDefinition = 'Location';
        break;
      default:
        break;
    }

    this.mixpanelService.track({
      eventName: eventName,
      eventDisplayName: eventDisplayName,
      kpi: 'User Engagement',
      trigger: 'On Dropdown Change',
      eventDefinition: `User changed the location ${type}`,
      propertyType: 'Event Property',
      propertyDefinition: propertyDefinition,
      additionalProperties: {
        leaseLocation: value,
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  private trackLeaseTermOtherChange(value: string): void {
    this.mixpanelService.track({
      eventName: 'What is your preferred lease term Other Value ?',
      eventDisplayName: value,
      kpi: 'User Engagement',
      trigger: 'On Input Change',
      eventDefinition: 'User changed the "Other" lease term option',
      propertyType: 'Event Property',
      propertyDefinition: 'Other Lease Term',
      additionalProperties: {
        LeaseTermOther: value,
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  setLeaseForm() {
    this.frmLeaseTerm.patchValue(this.objLeaseOptions);

    this.files =
      this.objLeaseOptions['sds'] !== '' ? this.objLeaseOptions['sds'] : [];

    this.getOtherLeaseTerm();

    if (this.frmLeaseTerm.value['preferred-lease-type'] === '')
      this.frmLeaseTerm
        .get('preferred-lease-type')
        ?.setValue([this.leaseOptions['preferred-lease-type'][0]]);

    if (this.frmLeaseTerm.value['rail-service-type'] === '')
      this.frmLeaseTerm
        .get('rail-service-type')
        ?.setValue(this.leaseOptions['rail-service-type'][0]);
    else {
      const serviceType = this.leaseOptions['rail-service-type'].filter(
        (item: any) => item.id == this.objLeaseOptions['rail-service-type'].id
      );
      this.frmLeaseTerm.get('rail-service-type')?.setValue(serviceType[0]);
    }

    if (this.frmLeaseTerm.value['preferred-rail-carrier-other'] !== '') {
      this.showCarrierOther = true;
    }
  }

  setCountryIndex(name: string) {
    if (name === '') this.selectedCountryIndex = -1;
    else
      this.selectedCountryIndex = this.countries.findIndex(
        (c: any) => c.name == name
      );
  }

  canUploadSDSFile(event: Event) {
    (event.target as HTMLInputElement).value = '';
    if (this.files.length < 2) {
      return true;
    } else {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }

  // on file drop handler
  onFileDropped(event: any) {
    if (this.files.length === 2) return;
    if (event !== null) {
      const file = event[0];
      const ext = file.name.split('.').pop();
      if (ext != 'pdf') {
        return;
      }
      this.prepareFileList(file);
    }
  }

  //handle file from browsing
  fileBrowseHandler(event: any) {
    if (this.files.length === 2) return;
    if (event !== null) {
      const file = event.files[0];
      const ext = file.name.split('.').pop();
      if (ext != 'pdf') {
        return;
      }
      this.prepareFileList(file);
    }
  }

  prepareFileList(file: File) {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      const fileData = {
        sds_name: file.name,
        sds_url: URL.createObjectURL(file),
        sds_data: fileReader.result,
      };

      this.files.push(fileData);
    };
    fileReader.readAsDataURL(file);
    this._holdFileService_.addFile(file);
  }

  deleteFile(index: number, inputFile: any) {
    const fileToCheck = this.sdsFileList.find(
      (file) => file.id === inputFile.id
    );
    if (fileToCheck) {
      fileToCheck.isChecked = false;
    }
    this.files.splice(index, 1);
  }

  getOptions(): any {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const leaseMechOptions$: Observable<any> = this.httpClient.post(
      this.config.leaseMechOptionsURL,
      {},
      { headers: headers }
    );
    const countries$: Observable<any> = this.httpClient.post(
      this.config.countriesURL,
      {},
      { headers: headers }
    );

    combineLatest([leaseMechOptions$, countries$]).subscribe(
      ([data, countries]) => {
        this.countries = countries.filter((x: any) => x.name !== 'All');
        this.frmLeaseTerm
          .get('country')
          ?.setValue(this.objLeaseOptions.country);
        this.changeCountry();

        this.leaseOptions = data['lease-details'];
        this.carriers = this.leaseOptions['preferred-rail-carrier'];
        if (this.carriers) {
          this.carriers.sort((a, b) => {
            if (a.name === 'Other' && b.name !== 'Other') {
              return 1;
            } else if (a.name !== 'Other' && b.name === 'Other') {
              return -1;
            } else {
              return a.name.localeCompare(b.name);
            }
          });
        }
        setTimeout(() => {
          const el = document.querySelector('#stateDropdown');
          if (el) {
            const ch = el.querySelector('.p-dropdown-label');
            if (ch) {
              if (ch.innerHTML) {
                ch.innerHTML = 'State/Province ' + '<i>Optional</i>';
              }
            }
          }
        }, 0);
        this.setLeaseForm();
      }
    );
  }

  next() {
    const obj = this.createSubmittedObj();

    this.quoteRequest['lease-details'] = obj;
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.REVIEW);
    this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.REVIEW);
  }

  createSubmittedObj() {
    const obj = this.frmLeaseTerm.value;
    obj['sds-available'] = this.files.length > 0 ? 'Yes' : 'No';
    obj['sds'] = this.files.length > 0 ? this.files : [];
    obj['isValid'] = this.frmLeaseTerm.valid;

    return obj;
  }

  carrierChange(event: any) {
    const index = event.value.find(
      (item: any) => item.name.toLowerCase() === 'other'
    );
    this.trackRailCarrierOtherChange(event);
    if (index) {
      this.showCarrierOther = true;
      return;
    }
    this.showCarrierOther = false;
    this.frmLeaseTerm.get('preferred-rail-carrier-other')?.setValue('');
  }

  focusInput(input: HTMLInputElement) {
    input.value = '';
    setTimeout(() => {
      input.focus();
    }, 0);
  }

  back() {
    const obj = this.createSubmittedObj();

    this.quoteRequest['lease-details'] = obj;
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.MECHANICAL_OPTIONS);
  }

  selectCheckbox(option: any, form: string) {
    this.frmLeaseTerm.get(form)?.setValue(option);
  }

  getMin() {
    const max = this.frmLeaseTerm.get('max');
    let minValue = this.frmLeaseTerm.value.min;

    if (minValue === '') minValue = 1;

    max?.setValidators([
      Validators.required,
      Validators.maxLength(6),
      Validators.min(minValue),
      Validators.max(999999),
    ]);
    return minValue;
  }

  getMax() {
    const min = this.frmLeaseTerm.get('min');
    let maxValue = this.frmLeaseTerm.value.max;

    if (maxValue === '') maxValue = 999999;

    min?.setValidators([
      Validators.required,
      Validators.min(1),
      Validators.max(maxValue),
    ]);
    return maxValue;
  }

  onchangeleaseOptions(event: any) {
    const idx = event.checked.find((x: any) => x.name === 'No Preference');
    const selectedOption =
      event.checked.length == 0
        ? null
        : event.checked[event.checked.length - 1].name;
    if (idx && selectedOption === 'No Preference') {
      this.frmLeaseTerm.get('preferred-lease-type')?.setValue('');
      this.frmLeaseTerm
        .get('preferred-lease-type')
        ?.setValue([this.leaseOptions['preferred-lease-type'][0]]);
    } else if (event.checked.length > 1 && idx) {
      this.frmLeaseTerm.get('preferred-lease-type')?.setValue('');
      for (const checkedItem of event.checked) {
        if (checkedItem.name !== 'No Preference')
          this.frmLeaseTerm
            .get('preferred-lease-type')
            ?.setValue([checkedItem]);
      }
    }
    this.trackLeaseOptionsChange(event);
  }

  private trackLeaseOptionsChange(event: any): void {
    this.mixpanelService.track({
      eventName: 'What is your preferred lease type?',
      eventDisplayName: event.checked.map((item: any) => item.name).join(', '),
      kpi: 'User Engagement',
      trigger: 'On Checkbox Change',
      eventDefinition: 'User changed lease options',
      propertyType: 'Event Property',
      propertyDefinition: 'Selected Lease Options',
      additionalProperties: {
        preferredLeaseType: event.checked.map((item: any) => item.name),
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }
  onchangeLeaseTerm(event: any): void {
    let index = 0;
    let otherChecked = false;
    for (const checkedElement of event.checked) {
      if (checkedElement.name === OTHER) {
        this.showleaseTermOther = true;
        this.leaseTermOtherIndex = index;
        otherChecked = true;
      }
      index++;
    }
    if (!otherChecked) {
      this.frmLeaseTerm.get('preferred-lease-term-other')?.setValue('');
      this.showleaseTermOther = false;
      this.leaseTermOtherIndex = -1;
    }

    // Track Mixpanel event
    this.trackLeaseTermChange(event);
  }

  private trackLeaseTermChange(event: any): void {
    this.mixpanelService.track({
      eventName: 'What is your preferred lease term?',
      eventDisplayName: event.checked.map((item: any) => item.name).join(', '),
      kpi: 'User Engagement',
      trigger: 'On Checkbox Change',
      eventDefinition: 'User changed lease term options',
      propertyType: 'Event Property',
      propertyDefinition: 'Selected Lease Term',
      additionalProperties: {
        preferredLeaseTerm: event.checked.map((item: any) => item.name),
        parentEvent: 'Begin Quote',
        subParentEvent: 'Lease Details',
      },
    });
  }

  getOtherLeaseTerm() {
    const leaseTerms = this.frmLeaseTerm.value['preferred-lease-term-other'];
    if (leaseTerms !== '') this.showleaseTermOther = true;
  }

  getSdsFileDetails(clientData: any) {
    this.sdsService.getSdsFile(clientData).subscribe((res: any) => {
      this.sdsFileList = res;
      this.sdsFileList = this.sdsFileList.map((item) => {
        item.isChecked = false;
        return item;
      });
    });
  }

  isSelect(event: any, data: any) {
    if (event.checked) {
      data.isChecked = true;
      const fileData = {
        sds_name: data?.files?.file_name,
        sds_url: data?.files?.file_path,
        sds_data: data?.files?.sds_data,
      };
      this.count = this.count + 1;
      if (this.files.length < 2) {
        this.files.push(fileData);
      }
    } else if (event.checked == false) {
      data.isChecked = false;
      this.files = this.files.filter(
        (item) => item.sds_name !== data.files.file_name
      );
    }
  }

  checkDisable(files: any) {
    return this.files.length >= 2 && !files.isChecked;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const val = this.frmLeaseTerm.get('leaseableDate')?.value;
      if (val) {
        this.frmLeaseTerm.get('leaseableDate')?.setValue(new Date(val));
      }
    }, 2000);
  }
}
